import * as React from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import { SectionTitle } from "@multiagentbook/ui";
import { labFiles } from "../../data/labs";

const siteMetadata = {
  description: "Interactive labs and examples for multi-agent systems",
  title: "Multi-Agent Labs",
  author: "Victor Dibia",
  image: "/images/og-card.png",
  keywords: "multi-agent systems, interactive labs, examples, experiments",
  twitterUsername: "@designingwithml",
};

export const LabCards = ({
  files = labFiles,
  isComponent = true,
}: {
  files: typeof labFiles;
  isComponent?: boolean;
}) => {
  return (
    <div
      className={`  ${
        isComponent ? "border-t border-secondary mt-20 pt-20 my-10" : " my-20 "
      }`}
    >
      <ul
        role="list"
        className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8"
      >
        {files.map((file, i) => (
          <li key={i + "itemrow"} className="relative">
            <Link to={file.url}>
              <div className="group aspect-h-7 aspect-w-10 block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100">
                <img
                  alt=""
                  src={file.image}
                  className="  pointer-events-none object-cover group-hover:opacity-75"
                />
                <button
                  type="button"
                  className="absolute inset-0 focus:outline-none"
                >
                  <span className="sr-only">View details for {file.title}</span>
                </button>
              </div>
              <p className="pointer-events-none mt-2 block truncate text-sm font-medium text-primary">
                {file.title}
              </p>
              <p className="pointer-events-none block text-sm font-medium text-secondary">
                {file.description}
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

const LabsPage = () => {
  return (
    <Layout meta={siteMetadata} title="Labs" link={"/labs"}>
      <div>
        <div
          style={{
            height: "28rem",
          }}
          className="relative bg-secondary   overflow-hidden  rounded   "
        >
          <div style={{ zIndex: 10 }} className="relative h-full ">
            <div
              style={{ zIndex: 9 }}
              className="z-10   w-full  flex flex-col h-full   relative"
            >
              {" "}
              <img
                style={{ zIndex: -100 }}
                className="absolute   h-full  right-0 top-0  "
                src="/images/bg.svg"
              />
              <div className="flex flex-col h-full">
                <div className="flex-1   "> </div>
                <div className=" sm:w-3/5  md:w-3/5 xl:w-3/5    p-6 rounded">
                  <SectionTitle
                    className=" mt-1"
                    title="Interactive Labs on Multi-Agent Concepts"
                  >
                    {" "}
                  </SectionTitle>

                  <div className="mb-4  text-lg md:text-xl font-light">
                    {" "}
                    Interactive examples, experiments, benchmarks and reports
                    that help make abstract concepts concrete.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>{" "}
        <LabCards files={labFiles} isComponent={false} />
      </div>
    </Layout>
  );
};

export default LabsPage;